import { SVGProps } from "react";

export default function SolBalanceIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width ? props.width : "29"}
      height={props.height ? props.height : "24"}
      viewBox="0 0 29 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M3.41037 24C7.08823 24 9.85217 20.8015 11.5016 18.274C11.301 18.8332 11.1896 19.3923 11.1896 19.9292C11.1896 21.4054 12.0366 22.4566 13.7083 22.4566C16.0042 22.4566 18.4561 20.4436 19.7266 18.274C19.6375 18.5871 19.5929 18.8779 19.5929 19.1463C19.5929 20.1752 20.1724 20.8239 21.3538 20.8239C25.0763 20.8239 28.8209 14.2255 28.8209 8.45481C28.8209 3.95899 26.5474 0 20.8412 0C10.8107 0 0 12.2572 0 20.1752C0 23.2842 1.67175 24 3.41037 24ZM17.3862 7.96274C17.3862 6.84438 18.0103 6.06153 18.9242 6.06153C19.8158 6.06153 20.4399 6.84438 20.4399 7.96274C20.4399 9.0811 19.8158 9.8863 18.9242 9.8863C18.0103 9.8863 17.3862 9.0811 17.3862 7.96274ZM22.1562 7.96274C22.1562 6.84438 22.7804 6.06153 23.6942 6.06153C24.5858 6.06153 25.21 6.84438 25.21 7.96274C25.21 9.0811 24.5858 9.8863 23.6942 9.8863C22.7804 9.8863 22.1562 9.0811 22.1562 7.96274Z"
        fill="#FFFDF8"
        className={props.className}
      />
    </svg>
  );
}
